import { SB } from '@play-co/replicant';

export const tutorialSchema = {
  tutorial: SB.object({
    basicGameplayShown: SB.boolean().default(false),
    chatWithPetsShown: SB.boolean().default(false),
    careForPetsShown: SB.boolean().default(false),
    friendReferralShown: SB.boolean().default(false),
    profileShown: SB.boolean().default(false),
    match3Shown: SB.boolean().default(false),
    visitFriendShown: SB.boolean().default(false),
    adult: SB.boolean().default(false),
    duoInvite: SB.boolean().default(false),
    duoInviteReceived: SB.boolean().default(false),
    decoration: SB.boolean().default(false),
    daycare: SB.boolean().default(false),
    airplane: SB.boolean().default(false),
    decorationBonus: SB.boolean().default(false),
    catalog: SB.boolean().default(false),
    accessory: SB.boolean().default(false),
    encyclopedia: SB.boolean().default(false),
    growthCapsule: SB.boolean().default(false),
    slots: SB.boolean().default(false),
    pinata: SB.boolean().default(false),
    bubbleSlot: SB.boolean().default(false),
    throwBuruBuru: SB.boolean().default(false),
    match2: SB.boolean().default(false),
    match2BattlePass: SB.boolean().default(false),
    decorationProgression: SB.boolean().default(false),
    bumbum: SB.boolean().default(false),
    airplaneSlots: SB.boolean().default(false),
    transform: SB.boolean().default(false),
    petCollection: SB.boolean().default(false),
    costumeBoost: SB.boolean().default(false),
    teams: SB.boolean().default(false),
    friendship: SB.boolean().default(false),
    makeHappy: SB.boolean().default(false),
    addFriends: SB.boolean().default(false),

    // TODO: Remove these items
    minigameBoost: SB.boolean().default(false).optional(),
    frenzyTutorial: SB.boolean().default(false).optional(),
    frenzyFirstSpin: SB.boolean().default(false).optional(),
    frenzyPointsGranted: SB.boolean().default(false).optional(),
    costumeGacha: SB.boolean().default(false).optional(),
    petSickShown: SB.boolean().default(false).optional(),
  }),
};
